


















export default
	name: 'accordionWrapper'

	props:
		block: Object
		openFirst:
			type: Boolean
			default: false

	computed:
		paneWidth: ->
			switch @block.maxWidth
				when "max-w-full" then "max-w"
				when "max-w" then "max-w-medium"
				else "max-w-small"

		classes: -> [
			@block.maxWidth
			@block.background
		]

	methods:
		hasBlocks: (pane) ->
			if pane.blocks?.length > 0 then return true
			else return false

